module.exports = __webpack_public_path__ + "img/logo_blanco.d4a91367.jpg";